import { render, staticRenderFns } from "./spam-header.vue?vue&type=template&id=0fe317ff&"
import script from "./spam-header.vue?vue&type=script&lang=ts&"
export * from "./spam-header.vue?vue&type=script&lang=ts&"
import style0 from "./spam-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports